import { useMatchRoute } from "@tanstack/react-router";
import { KitMenuTemplate } from "../KitMenuTemplate";
import { SETTINGS_GROUP_PARTIAL } from "./hooks";
import { KitTypeMenuProps } from "./types";

export const InterviewMenu: React.FC<KitTypeMenuProps> = ({
  mode,
  groupSlug,
  kit,
}) => {
  const matchRoute = useMatchRoute();
  const groups = [
    {
      ...SETTINGS_GROUP_PARTIAL,
      active: !!matchRoute({
        to: "/w/$groupSlug/k/$kitUuid/interview-settings",
        params: { groupSlug, kitUuid: kit.uuid },
      }),
      link: {
        to: "/w/$groupSlug/k/$kitUuid/interview-settings" as const,
        params: { groupSlug, kitUuid: kit.uuid },
      },
    },
  ];
  return <KitMenuTemplate kit={kit} groups={groups} mode={mode} />;
};
